import { render, staticRenderFns } from "./GbNavbar.vue?vue&type=template&id=ed254d3e&scoped=true"
import script from "./GbNavbar.vue?vue&type=script&lang=js"
export * from "./GbNavbar.vue?vue&type=script&lang=js"
import style0 from "./GbNavbar.vue?vue&type=style&index=0&id=ed254d3e&prod&lang=less"
import style1 from "./GbNavbar.vue?vue&type=style&index=1&id=ed254d3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed254d3e",
  null
  
)

export default component.exports